import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { useState } from "react";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";
import { ICommonServiceProps } from "@api/types/globalService.types";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetAllFeatureCategoriesService = ({
  enableQuery = true,
  page = "1",
  per_page = "15",
  cacheKeys = [],
  filters = {},
}: ICommonServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const created_between = urlQueries["created_between"] || "";
  const segmentId = urlQueries["segment-id"] || "";
  const allFeatureCategoriesService = useQuery({
    queryKey: [
      ...CACHE_KEYS.FEATURE_CATEGORIES,
      debouncedQuery,
      page,
      per_page,
      segmentId,
      created_between,
      JSON.stringify(filters),
      ...cacheKeys,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.FEATURE_CATEGORIES,
        searchParams: {
          "filter[name]": debouncedQuery,
          "filter[segment_id]": segmentId,
          "filter[created_between]": created_between,
          page,
          per_page,
          include: "segment",
          ...filters,
        },
      }),
    enabled: enableQuery,
  });
  return {
    services: { allFeatureCategoriesService },
    states: { searchQuery, setSearchQuery },
  };
};
